import {FormattedMessage} from 'react-intl';

import {createElement, PropTypes} from 'rlink-react';
import LegacyScrollTransition from 'rlink-transitions/LegacyScrollTransition';

export default function IntroPanelEldar ({css}) {
  return (
    <LegacyScrollTransition css={css}>
      <div className={css['panel-content']}>
        <h3 className={css.top}>
          <span className={css.first}>
            <FormattedMessage
              id="ui.branding.heading.DOW3_ELDAR_INTRO_PANEL_ANIMATED_TAGLINE"
              defaultMessage="eldar"
              description="Animated tagline appearing on the Eldar faction page." />
          </span>
        </h3>
        <hr className={css.short} />
        <p className={css.top}>
          <FormattedMessage
            id="ui.branding.copy.DOW3_ELDAR_INTRO_PANEL_BODY_FIRST"
            defaultMessage="The Eldar are the last survivors of an ancient civilization that once ruled the Galaxy. They have fearsome psychic powers and wield highly sophisticated weapons."
            description="Paragraph description of the Eldar faction." />
        </p>
        <p className={css.middle}>
          <FormattedMessage
            id="ui.branding.copy.DOW3_ELDAR_INTRO_PANEL_BODY_SECOND"
            defaultMessage="Each Eldar has a lifetime of experience, skill and knowledge, but they are highly dismissive of lesser creatures (including humans) who they feel are now infesting the Galaxy."
            description="Paragraph description of the Eldar faction." />
        </p>
        <p className={css.bottom}>
          <FormattedMessage
            id="ui.branding.copy.DOW3_ELDAR_INTRO_PANEL_BODY_THIRD"
            defaultMessage="Their armies ride upon grav tanks and jetbikes, descending on unsuspecting worlds with speed and fury."
            description="Paragraph description of the Eldar faction." />
        </p>
      </div>
    </LegacyScrollTransition>
  );
}

IntroPanelEldar.propTypes = {
  css: PropTypes.object,
};



// WEBPACK FOOTER //
// ./apps/www.dawnofwar.com/src/components/IntroPanelEldar.jsx